import AbstractModel from './AbstractModel'
import Mapper from './mapper/Mapper'
import Column from './table/Column'
import DateColumn from './table/DateColumn'

class GiorniApertura extends AbstractModel {
  permission () {
    return {
      'USR': {
        action: { isInsertable: true, isEditable: true, isDeletable: true },
        columns: {}
      },
      'ADM': {
        action: { isImpersonate: false, isInsertable: true, isEditable: true, isDeletable: true },
        columns: {}
      }
    }
  }
  mapper () {
    return [
      Mapper.column.azienda(true)
    ]
  }
  columns () {
    return [
      new Column('btn').withHtml(true).withWidth('100px').withIsEditable(false).withIsInsertable(false).withExportable(false),
      new Column('id').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('idazi').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new DateColumn('data_inizio'),
      new DateColumn('data_fine'),
      new Column('lunedi').withType('boolean').withHtmlType('switch'),
      new Column('martedi').withType('boolean').withHtmlType('switch'),
      new Column('mercoledi').withType('boolean').withHtmlType('switch'),
      new Column('giovedi').withType('boolean').withHtmlType('switch'),
      new Column('venerdi').withType('boolean').withHtmlType('switch'),
      new Column('sabato').withType('boolean').withHtmlType('switch'),
      new Column('domenica').withType('boolean').withHtmlType('switch')
    ]
  }

  validator () {
    return {
    }
  }
}

export default new GiorniApertura()
